import React, {useEffect, useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {_commonSetCommonInfo, _commonTimestampToDate, _phoneCall} from "../helpers/common";
import {_databaseGetNotice} from "../helpers/database";
import {getEtcInfoJson} from "./FetchData";

import "../css/etc_info.css";

function EtcInfo (props) {

    const navigate = useNavigate();
    let noticeListTemp = [];
    const [noticeList, setNoticeList] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState([]);
    const [accountNumber, setAccountNumber] = useState([]);
    const [accountHolder, setAccountHolder] = useState([]);

    useEffect(()=> {
        window.addEventListener('resize', handleResize);
        handleResize();

        _databaseGetNotice(function (id, notice) {
            notice.key = id;
            noticeListTemp = [notice].concat(noticeListTemp);
            setNoticeList(noticeListTemp);
        });
        _commonSetCommonInfo("selected_notice_id", null);
        _commonSetCommonInfo("selected_notice", null);

        setPhoneNumber(getEtcInfoJson().phone);
        setAccountNumber(getEtcInfoJson().account.number);
        setAccountHolder(getEtcInfoJson().account.holder);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    const handleResize = (e) => {

        var innerWidth = window.innerWidth;
        if(innerWidth > 1000) {

            document.getElementById("etc_info_intro").setAttribute("rowSpan", 2);
            document.getElementById("etc_info_intro").removeAttribute("colSpan", 2);

            if(document.getElementById("temp_tr") != null) {
                document.getElementById("etc_info_intro").insertAdjacentElement("afterend", document.getElementById("etc_info_notice"));
                document.getElementById("temp_tr").remove();
            }

        }else {

            document.getElementById("etc_info_intro").setAttribute("colSpan", 2);
            document.getElementById("etc_info_intro").removeAttribute("rowSpan", 2);

            if(document.getElementById("temp_tr") == undefined) {
                var tr = document.createElement("tr");
                tr.setAttribute("id", "temp_tr");
                tr.appendChild(document.getElementById("etc_info_notice"));
                document.getElementById("etc_info_intro").parentNode.insertAdjacentElement("afterend", tr);
            }

            if(innerWidth < 520) {
                if(document.getElementById("temp_account_tr") == undefined) {
                    var account_tr = document.createElement("tr");
                    account_tr.setAttribute("id", "temp_account_tr");
                    account_tr.appendChild(document.getElementById("etc_info_account"));
                    document.getElementById("etc_info_call").parentNode.insertAdjacentElement("afterend", account_tr);
                }
            }else {
                if(document.getElementById("temp_account_tr") != null) {
                    document.getElementById("etc_info_call").insertAdjacentElement("afterend", document.getElementById("etc_info_account"));
                    document.getElementById("temp_account_tr").remove();
                }
            }
        }
    }

    return (
        <div className="etc_info">
            <table>
                <thead></thead>
                <tbody>
                <tr>
                    <td id="etc_info_intro">
                        <div>
                            <div>JAYEONNURI PENSION</div>
                            <div>Happiness & Comfort</div>
                            <div>여러분의 행복한 여행을 위해<br/>항상 쾌적하고 안락한 휴식처를 제공하기 위해 노력하겠습니다</div>
                            <div>
                                <img src="https://postfiles.pstatic.net/MjAyMjA3MzBfMjM3/MDAxNjU5MTUwMjg0NDIz.5B3M9J7gYsUw5AlSsl-0dj4L0RNh08-jcV_UnT_Bu28g.KE-1SNyOShQpi6KsUpzjFNkSMPHQpj-JHhLIJku695cg.JPEG.bse14/bottom.jpg?type=w966" />
                            </div>
                        </div>
                    </td>
                    <td id="etc_info_notice" colSpan={2}>
                        <div>
                            <div>Notice</div>
                            {noticeList.length > 0 &&
                            <table>
                                <thead>
                                <tr>
                                    <th className="notice_title">제목</th>
                                    <th className="notice_author">작성자</th>
                                    <th>등록일</th>
                                </tr>
                                </thead>
                                <tbody>
                                {noticeList.map((data, index) => {
                                    return <tr key={index}
                                               id={data.key}
                                               onClick={(e) => {
                                                   _commonSetCommonInfo("selected_notice_id", data.key);
                                                   _commonSetCommonInfo("selected_notice", data);
                                                   navigate("/notice_steps/COMMUNITY?detail");
                                               }} >
                                        <td className="notice_cont_title">{data.title}</td>
                                        <td>{data.author}</td>
                                        <td className="list_time">{_commonTimestampToDate(data.time)}</td>
                                    </tr>
                                })}
                                </tbody>
                            </table>
                            }
                            {noticeList.length === 0 &&
                            <div>
                                공지사항이 없습니다.
                            </div>
                            }
                        </div>
                    </td>
                </tr>
                <tr>
                    <td id="etc_info_call">
                        <div>
                            <div>[문의사항]</div>
                            <div onClick={(e)=>{_phoneCall(phoneNumber)}}>{phoneNumber}</div>
                        </div>
                    </td>
                    <td id="etc_info_account">
                        <div>
                            <div>[입금계좌] </div>
                            <div>{accountNumber}</div>
                            <div>{accountHolder}</div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default EtcInfo;
